import { Prisma } from '@prisma/client'
import {
  ArrowLeftRight,
  CircleDollarSign,
  DollarSign,
  Edit,
  LucideEllipsis,
  View,
} from 'lucide-react'
import Link from 'next/link'
import { Button } from '../button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
  DropdownMenuTrigger,
} from '../dropdown-menu'

export default function AccountsMenu({
  account,
}: {
  account: Prisma.AccountGetPayload<{}>
}) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <LucideEllipsis />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuLabel>
          {account.primaryContactFirstName} {account.primaryContactLastName}
        </DropdownMenuLabel>

        <Link href={`/accounts/${account.id}`}>
          <DropdownMenuItem>
            <View />
            View Account
          </DropdownMenuItem>
        </Link>

        <Link href={`/accounts/edit/${account.id}`}>
          <DropdownMenuItem>
            <Edit />
            Edit Account
          </DropdownMenuItem>
        </Link>

        <DropdownMenuSub>
          <DropdownMenuSubTrigger>
            <ArrowLeftRight />
            Add Transaction
          </DropdownMenuSubTrigger>
          <DropdownMenuSubContent>
            <Link
              href={`/transactions/add?accountId=${account.id}&type=payment`}
            >
              <DropdownMenuItem>
                <DollarSign /> Payment
              </DropdownMenuItem>
            </Link>
            <Link
              href={`/transactions/add?accountId=${account.id}&type=charge`}
            >
              <DropdownMenuItem>
                <CircleDollarSign /> Charge
              </DropdownMenuItem>
            </Link>
          </DropdownMenuSubContent>
        </DropdownMenuSub>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
